import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Organisation } from 'src/app/global/global.model';
import { PaymentMethodType, ReceiptItemParkingResponse, ReceiptItemPrepaidParkingResponse, ReceiptItemSubscriptionResponse, ReceiptResponse, TransactionType } from '@bciti/types';
import { ReceiptPrintService } from '../../../global/utils/receipt-print/receipt-print.service';
import { organisationSelector } from 'src/app/global/store/global.selectors';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store';

@Component({
    selector: 'app-user-receipt-detail',
    templateUrl: './user-receipt-detail-dialog.component.html',
    styleUrls: ['./user-receipt-detail-dialog.component.scss'],
})
export class UserReceiptDetailDialogComponent implements OnInit {
    TransactionType = TransactionType;
    PaymentMethodType = PaymentMethodType;

    org: Organisation;

    loading = false;

    fullDateTimeOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    } as const;

    shortDateOptions = {
        dateStyle: 'short',
    };

    shortTimeOptions: Intl.DateTimeFormatOptions = {
        timeStyle: 'short',
    } as any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ReceiptResponse<ReceiptItemSubscriptionResponse | ReceiptItemParkingResponse | ReceiptItemPrepaidParkingResponse>,
        private store: Store<State>,
        private translate: TranslateService,
        private dialogRef: MatDialogRef<UserReceiptDetailDialogComponent>,
        private receiptPrintService: ReceiptPrintService,
    ) {}

    taxNumber(taxName: string, taxNumber: string) {
        return `${taxName || this.translate.instant('user-receipts.detail.tax')} (${taxNumber})`;
    }

    ngOnInit() {
        this.store.select(organisationSelector).subscribe((organisation) => {
            this.org = organisation;
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    isBadDate(date: string): boolean {
        return date === '1970-01-01T00:00:00.000Z';
    }

    get isUDES(): boolean {
        return this.org.tag === 'UDES';
    }

    getItemNameOrDescription(name: string, description: string): string {
        if (!name || name === '-') {
            return description;
        }

        if (this.isUDES) {
            const regex = /(\d{4}-\d{2}-\d{2})/g;
            return name.replace(regex, '<span style="font-weight:700;">$1</span>');
        }

        return name;
    }

    generatePDF(): void {
        window.open(this.receiptPrintService.generatePDF(this.data, this.translate).url as string, '_blank');
    }
}
